import React from 'react';
import { ArrowRight, Download } from 'lucide-react';
import { Section } from '../ui/Section';
import { Button } from '../ui/Button';
import { BrandCurve } from '../ui/BrandCurve';
const chips = ['Independent', 'Non-intrusive', 'Plain-English findings', 'Practical next steps'];
export function MidCTA() {
  return <Section className="relative overflow-hidden bg-navy" ariaLabel="Start with an independent view" data-id="element-372">
      <div className="pointer-events-none absolute inset-0" style={{
      background: 'radial-gradient(80% 90% at 50% 0%, rgba(0,168,232,0.14), transparent 60%)'
    }} aria-hidden data-id="element-373" />
      <BrandCurve className="-right-40 -top-24 h-[440px] w-[440px] md:-right-24" data-id="element-374" />
      <div className="relative mx-auto max-w-3xl text-center" data-id="element-375">
        <h2 className="font-display text-[28px] font-black leading-tight text-white md:text-[40px]" data-id="element-376">
          Not ready to change providers? Start with an independent view.
        </h2>
        <p className="mx-auto mt-5 max-w-2xl text-[17px] leading-relaxed text-white/75 md:text-[18px]" data-id="element-377">
          The IT Review helps you understand what is working, where
          responsibility is unclear and which issues deserve attention first.
        </p>
        <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row" data-id="element-378">
          <Button as="a" href="#it-review" variant="primary" data-id="element-379">
            Book an independent IT Review
            <ArrowRight className="h-4 w-4" aria-hidden data-id="element-380" />
          </Button>
          <Button as="a" href="#resources" variant="ghost" data-id="element-381">
            <Download className="h-4 w-4" aria-hidden data-id="element-382" />
            Download the IT Review Explainer
          </Button>
        </div>
        <div className="mt-8 flex flex-wrap items-center justify-center gap-3" data-id="element-383">
          {chips.map(c => <span key={c} className="rounded-full border border-white/15 bg-white/[0.06] px-4 py-1.5 text-[13px] font-semibold text-white/85" data-id="element-384">
              {c}
            </span>)}
        </div>
      </div>
    </Section>;
}